import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import { useRestaurantsListStore } from './restaurant-list-store';

export const useRestaurantsListSearchStore = defineStore('restaurantsListSearch', () => {
    const listStore = useRestaurantsListStore();

    const { setSearchedCoords } = listStore;

    const currentQuery = ref(null);
    const searchedQuery = ref(null);
    const searching = ref(false);
    const geolocationLoading = ref(false);

    /**
     * Reset the state to non-searching mode.
     */
    function reset() {
        currentQuery.value = null;
        searchedQuery.value = null;
        searching.value = false;

        setSearchedCoords(null);
    }

    return {
        currentQuery,
        searchedQuery,
        searching,
        geolocationLoading,
        reset,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useRestaurantsListSearchStore, import.meta.hot));
}
